function scrollTop() {
  const scrollTopButton = document.querySelector<HTMLButtonElement>(".js-scrolltop");

  // scrollTopButtonがnullでないことを確認
  if (!scrollTopButton) {
    console.warn("Scroll top button not found.");
    return; // ボタンが見つからない場合は、関数を終了
  }

  // 初期状態を設定
  scrollTopButton.style.opacity = "0";
  scrollTopButton.style.visibility = "hidden";

  // スクロールイベントを追加
  window.addEventListener("scroll", () => {
    if (window.scrollY > 200) {
      scrollTopButton.style.opacity = "1";
      scrollTopButton.style.visibility = "visible";
    } else {
      scrollTopButton.style.opacity = "0";
      scrollTopButton.style.visibility = "hidden";
    }
  });

  scrollTopButton.addEventListener("click", () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  });
}

export { scrollTop };
